import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const AboutPreview = () => {
    return (
        <section
            data-testid="about-preview-section"
            className="bg-[var(--st-cream)] relative z-10 py-24 lg:py-36"
        >
            <div className="st-container">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-16 gap-y-12 items-start">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.96 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9 }}
                        className="lg:col-span-5 lg:col-start-1"
                    >
                        <div className="w-full">
                            <img
                                src="https://customer-assets-lxgj4vgw.emergentagent.net/job_silver-studio-new/artifacts/54e54w3z_Screenshot%202026-07-21%20at%205.38.00%E2%80%AFPM.png"
                                alt="Sugandhi Luthra, founder of SilverTree"
                                className="w-full h-auto block"
                                loading="lazy"
                            />
                        </div>
                        <div className="mt-5 flex items-baseline gap-4 border-t border-[var(--st-line)] pt-4">
                            <span className="font-serif italic text-xl">Sugandhi Luthra</span>
                            <span className="eyebrow text-[var(--st-gold-deep)]">Founder</span>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9, delay: 0.15 }}
                        className="lg:col-span-6 lg:col-start-7"
                    >
                        <p className="eyebrow mb-5 text-[var(--st-gold-deep)]">06 — A word from the founder</p>
                        <h2 className="font-serif leading-[0.95] tracking-tighter" style={{ fontSize: "clamp(2.6rem, 6vw, 5.5rem)" }}>
                            Some studios<br />
                            build brands.<br />
                            <span className="italic text-[var(--st-gold)]">We build the ones<br />you remember.</span>
                        </h2>
                        <p className="mt-8 text-base lg:text-lg leading-relaxed text-[var(--st-ink-soft)] max-w-xl">
                            A boutique studio founded and solely owned by Sugandhi Luthra,
                            working across Gurgaon and Kuala Lumpur. Deliberately small at
                            the core, with a network of long-term specialist associates on
                            call — the range of a full agency without the overhead, the
                            hand-offs, or the junior-team guesswork.
                        </p>
                        <p className="mt-4 font-serif italic text-lg text-[var(--st-gold-deep)]">
                            You work with the founder. The right experts work with her.
                        </p>
                        <Link to="/about" data-testid="about-cta-full-story" className="btn-ghost mt-10">
                            Read the full story <ArrowUpRight size={16} />
                        </Link>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default AboutPreview;
